/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timeline-scale-tick[_ngcontent-%COMP%]{position:absolute;bottom:0;display:block;height:14px;line-height:12px;padding-left:4px;margin-left:-1px;border-left:1px solid #86bce3}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-scale/timeline-scale-tick/timeline-scale-tick.component.styl.shim.ngstyle.js.pre-build-optimizer.js